// Formateo de dinero compartido en toda la app: agrega separador de miles y el signo $.
export const fmtMoney = (n, decimals = 2) =>
  new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN',
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(n || 0);
